import * as ko from "knockout";
import Bao from "./../../services/bao-service";
function DiaryModuleViewModel(parent) {
    var self = this;
    self.Bao = Bao;
    self.parent = parent;
    self.FilterDiaryDate = ko.observable();
    self.FilterDiary = ko.observable();
    self.Initialized = ko.observable(false);
    self.DiaryCollection = ko.observableArray([]);
    self.TotalRows = ko.observable(0);
    self.PageSize = ko.observable(20);
    self.PageIndex = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.SelectedRow = ko.observable({});
    self.IsLoading = ko.observable(false);
    self.SelectRow = function (item) {
        self.SelectedRow(item);
        return true;
    };
    self.DisplayTotalRows = ko.computed(function () {
        if (self.TotalRows() <= self.PageSize()) {
            return self.TotalRows();
        }
        else {
            return self.PageSize() + " / " + self.TotalRows();
        }
    });
    self.PageIndex.subscribe(function () {
        self.Load();
    });

    self.PageSize.subscribe(function () {
        if (self.Initialized()) {
            self.PageIndex(0);
            self.Load();
        }
    });

    self.Sorting.subscribe(function () {
        self.Load();
    });
    self.SelectedDiaryOption = ko.observable();
    self.SelectedDiaryDateOption = ko.observable();
    self.DiaryOptions = ko.observableArray([]);
    self.DiaryDateOptions = ko.observableArray([]);
    self.fillFilter = function () {
        self.DiaryOptions.push({
            DiaryFilterText: Bao.Session.GetMessage("msgGridColDiaryModule_JustMy"),
            DiaryFilterValue: 1
        }, {
            DiaryFilterText: Bao.Session.GetMessage("msgGridColDiaryModule_OnlyDeputy"),
            DiaryFilterValue: 2
        }, {
            DiaryFilterText: Bao.Session.GetMessage("msgGridColDiaryModule_DetectedByMe"),
            DiaryFilterValue: 4
        }, {
            DiaryFilterText: Bao.Session.GetMessage("msgGridColDiaryModule_All"),
            DiaryFilterValue: 3
        });
    };
    self.FilterDiary.subscribe(function (item) {
        self.SelectedDiaryOption(null);
        self.SelectedDiaryOption(item);
        self.Refresh();
    });
    self.fillDateFilter = function () {
        self.DiaryDateOptions.push({
            DiaryDateFilterText: Bao.Session.GetMessage("msgGridColDiaryModule_Open"),
            DiaryDateFilterValue: 1
        }, {
            DiaryDateFilterText: Bao.Session.GetMessage("msgGridColDiaryModule_InFourWeeks"),
            DiaryDateFilterValue: 2
        }, {
            DiaryDateFilterText: Bao.Session.GetMessage("msgGridColDiaryModule_Overdue"),
            DiaryDateFilterValue: 3
        });
    };
    self.FilterDiaryDate.subscribe(function (item) {
        self.SelectedDiaryDateOption(null);
        self.SelectedDiaryDateOption(item);
        self.Refresh();
    });
    self.Refresh = function () {
        return Bao.post("SynosetStartModule/GetDiaryItems", JSON.stringify({
            selectedDiaryOption: self.SelectedDiaryOption(),
            selectedDiaryDateOption: self.SelectedDiaryDateOption(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            self.Initialized(true);
            if (searchResult != null) {
                self.DiaryCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
        });
    };
    self.Load = function () {
        var def = $.Deferred();
        if (self.Initialized()) {
            self.IsLoading(true);
            Bao.post("SynosetStartModule/GetDiaryItems", JSON.stringify({
                selectedDiaryOption: self.SelectedDiaryOption(),
                selectedDiaryDateOption: self.SelectedDiaryDateOption(),
                pageIndex: self.PageIndex(),
                pageSize: self.PageSize(),
                sorting: self.Sorting()
            }), function (searchResult) {
                self.SelectedRow(null);
                self.TotalRows(0);
                self.DiaryCollection([]);
                if (searchResult != null && searchResult.Models != null) {
                    self.DiaryCollection(searchResult.Models);
                    self.TotalRows(searchResult.TotalRows);
                }
                def.resolve();
                self.IsLoading(false);
            });
        }
        else {
            def.resolve();
        }
        return def.promise();
    };
    self.parent.Refresh = function () {
        self.Load();
    };
    self.init = function () {
        self.fillFilter();
        self.fillDateFilter();
        return Bao.post("SynosetStartModule/GetDiaryItems", JSON.stringify({
            selectedDiaryOption: self.SelectedDiaryOption(),
            selectedDiaryDateOption: self.SelectedDiaryDateOption(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            self.Initialized(true);
            if (searchResult != null) {
                self.DiaryCollection(searchResult.Models);
            }
        });
    };
    self.loaded = function () {
        return self.Load();
    };
}
export default DiaryModuleViewModel;